//React Icons
import { RiWhatsappFill } from "react-icons/ri";
import useWindowWidth from '../../hooks/useWindowWidth';

const WhatsappButton = ({onClick, modalIsOpen, x="right", y="bottom"}) => {

    let windowWidth = useWindowWidth()

    //Se posiciona el botón según los valores que se asignen a X (left/right) y a Y (top/bottom)
    const style = {
        left: `${x === 'left' ? '2rem' : 'unset'}`,
        right: `${x === 'right' ? '2rem' : 'unset'}`,
        top: `${y === 'top' ? '2rem' : 'unset'}`,
        bottom: `${y === 'bottom' ? '1.2rem' : 'unset'}`
    }

    if(windowWidth >= 768) {
        style.bottom = '2rem'
    }

    return(
        <button onClick={onClick} className={`whatsapp__btn ${modalIsOpen ? 'hidden' : ''}`} style={style}>
            <RiWhatsappFill size="100%" />
            <span className="background-circle"></span>
        </button>
    )
}

export default WhatsappButton